/**
 * Set the width of a input to the length of the palceholder
 */
$("input[placeholder]").each(function() {
    $(this).attr('size', $(this).attr('placeholder').length);
});
